import type { Transform } from "web_myplann/Chat/Types/pinchZoom";

export const MIN_SCALE = 1;
export const MAX_SCALE = 5;

export const IDENTITY_TRANSFORM: Transform = { scale: 1, x: 0, y: 0 };
